import { useState, useEffect } from 'react'
import { ChevronDown, Menu, X } from 'lucide-react'
import logo from '../../assets/images/hypercognitive-logo.jpg'
import {Link} from "react-router-dom"
export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <nav className="fixed top-0 w-full z-50 bg-black/30 backdrop-blur-lg border-b border-white/10">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        {/* Logo */}
        {/* Logo */}
        <a href="/" className="flex items-center gap-2">
          <img
            src={logo}
            alt="Forward Digital Logo"
            className="h-8 w-8 mix-blend-screen"
          />
          <h1 className="text-xl font-bold tracking-wider text-white">
            HYPER COGNITIVE
            {/* <span className="block text-xs tracking-wider text-white/80">DIGITAL</span> */}
          </h1>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden items-center space-x-8 md:flex">
          <a
            href="/aiDAPTIV+"
            className="text-base font-medium text-white/90 transition-colors hover:text-white"
          >
            aiDAPTIV+
          </a>
          <a
            href="/solutions"
            className="text-base font-medium text-white/90 transition-colors hover:text-white"
          >
            Solutions
          </a>
          <a
            href="/appliances"
            className="text-base font-medium text-white/90 transition-colors hover:text-white"
          >
            Hardware
          </a>
          <a
            href="/about"
            className="text-base font-medium text-white/90 transition-colors hover:text-white"
          >
            About
          </a>
         
          
          {/* More Dropdown */}
          <div className="relative">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex items-center text-base font-medium text-white/90 transition-colors hover:text-white"
            >
              More <ChevronDown className={`ml-1 h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
              <div className="absolute right-0 mt-2 w-72 rounded-lg border border-white/10 bg-black/80 backdrop-blur-xl">
                <div className="rounded-lg py-1">
                  <a
                    href="/faqs"
                    className="flex items-center space-x-3 px-4 py-3 text-sm text-white/90 transition-colors hover:bg-white/10 hover:text-white"
                  >
                    <span>FAQs</span>
                  </a>
                  {/* <a
                    href="/services"
                    className="flex items-center space-x-3 px-4 py-3 text-sm text-white/90 transition-colors hover:bg-white/10 hover:text-white"
                  >
                    <span>Services</span>
                  </a> */}
                  {/* <a
                    href="/blog"
                    className="flex items-center space-x-3 px-4 py-3 text-sm text-white/90 transition-colors hover:bg-white/10 hover:text-white"
                  >
                    <span>Blog</span>
                  </a> */}
                  {/* <a
                    href="/careers"
                    className="flex items-center space-x-3 px-4 py-3 text-sm text-white/90 transition-colors hover:bg-white/10 hover:text-white"
                  >
                    <span>Careers</span>
                  </a> */}
                </div>
              </div>
            )}

          </div>
          <a href="/contact">
          {/* Contact Button */}
          <button 
            className="rounded-full border-2 border-emerald-500/80 px-6 py-2 text-base font-medium text-white shadow-[0_0_15px_rgba(168,85,247,0.2)] transition-all hover:border-emerald-400 hover:bg-emerald-500/10 hover:shadow-[0_0_20px_rgba(168,85,247,0.3)]"
          >
            Contact Us
          </button></a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="rounded-lg p-2 text-white/90 hover:text-white md:hidden"
        >
          {isMobileMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="border-t border-white/10 bg-black/80 backdrop-blur-xl md:hidden">
          <div className="flex flex-col space-y-4 p-4">
            <a href="/aiDAPTIV+" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              aiDAPTIV+
            </a>
            <a href="/solutions" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              Solutions
            </a>
            <a href="/appliances" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              Appliances
            </a>
            <a href="/about" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              About
            </a>
            <a href="/faqs" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              FAQs
            </a>
            {/* <a href="/services" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              Services
            </a> */}
            {/* <a href="/careers" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              Careers
            </a> */}
            {/* <a href="/work" className="text-base font-medium text-white/90 transition-colors hover:text-white">
              Work
            </a> */}
            <a href="/contact">
            <button 
              className="rounded-full border-2 border-emerald-500/80 px-6 py-2 text-base font-medium text-white shadow-[0_0_15px_rgba(168,85,247,0.2)] transition-all hover:border-emerald-400 hover:bg-emerald-500/10 hover:shadow-[0_0_20px_rgba(168,85,247,0.3)]"
            >
              Contact Us
            </button>
            </a>
          </div>
        </div>
      )}
    </nav>
  )
}

